import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlGridTagNames, AtlGridTwoColsWithLateralProps } from './grid.props';
import classNames from 'classnames';
import { getGlobalStyleSheets } from '../../global-styles';

@customElement(AtlGridTagNames.GridTwoColsWithLateral)
export class AtlGridTwoColsWithLateral
   extends LitElement
   implements AtlGridTwoColsWithLateralProps
{
   declare internalId: string;
   declare internalClassName?: string;
   declare internalMainClassName?: string;
   declare internalLateralClassName?: string;

   static properties = {
      internalId: { type: String, attribute: 'internal-id' },
      internalClassName: { type: String, attribute: 'internal-class-name' },
      internalMainClassName: {
         type: String,
         attribute: 'internal-main-class-name',
      },
      internalLateralClassName: {
         type: String,
         attribute: 'internal-lateral-class-name',
      },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   render() {
      return html`
         <div
            id=${this.internalId}
            class=${classNames(
               'row grid-two-col-with-lateral',
               this.internalClassName
            )}
         >
            <div class=${classNames('col-md-8', this.internalMainClassName)}>
               <slot name="slotMain"></slot>
            </div>
            <div class=${classNames('col-md-4', this.internalLateralClassName)}>
               <slot name="slotLateral"></slot>
            </div>
         </div>
      `;
   }
}
